exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".save-tpl-head[data-v-0a71241c]{display:flex;align-items:center;margin-bottom:18px}.save-tpl-icon[data-v-0a71241c]{font-size:24px;color:#2b5fd9;margin-right:8px}.save-tpl-title[data-v-0a71241c]{font-size:20px;font-weight:600}.save-tpl-label[data-v-0a71241c]{font-size:14px;margin-bottom:6px;color:#333}.save-tpl-label .required[data-v-0a71241c]{color:#ed4014}.save-tpl-footer[data-v-0a71241c]{text-align:right;margin-top:10px}.save-tpl-footer button[data-v-0a71241c]{min-width:88px;margin-left:10px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0a71241c","scoped":true,"hasInlineConfig":false}!./node_modules/less-loader/dist/cjs.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./node_modules/iview-loader??ref--5!./src/component/data-grid/custom-query/components/save-template-modal.vue
// module id = 117
// module chunks = 0